import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const measurementId = "G-H77YE43YNE";

const sendEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};

function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (document.querySelector(`script[data-astro-ga="${measurementId}"]`)) return undefined;

    const load = () => {
      if (document.querySelector(`script[data-astro-ga="${measurementId}"]`)) return;
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.dataset.astroGa = measurementId;
      document.head.appendChild(script);
    };

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(load, { timeout: 2000 });
      return () => window.cancelIdleCallback?.(idleId);
    }

    const timeoutId = window.setTimeout(load, 1200);
    return () => window.clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    sendEvent("page_view", {
      page_path: `${pathname}${search}`,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [pathname, search]);

  useEffect(() => {
    const onClick = (event) => {
      const link = event.target.closest?.("a");
      if (!link) return;

      const href = link.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        sendEvent("contact_click", { method: "phone", page_path: window.location.pathname });
        return;
      }
      if (href.startsWith("mailto:")) {
        sendEvent("contact_click", { method: "email", page_path: window.location.pathname });
        return;
      }

      try {
        const url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin && url.pathname === "/1/contact-us") {
          sendEvent("quote_cta_click", { page_path: window.location.pathname });
        }
      } catch (_) {
        // Ignore malformed or non-navigation href values.
      }
    };

    const onSubmit = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if ((form.getAttribute("action") || "").includes("formspree.io/")) {
        sendEvent("quote_form_submit", { page_path: window.location.pathname });
      }
    };

    const onChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
      if (target.name === "service" && target.value) {
        sendEvent("service_selection", {
          service: target.value,
          page_path: window.location.pathname,
        });
      }
    };

    document.addEventListener("click", onClick, true);
    document.addEventListener("submit", onSubmit, true);
    document.addEventListener("change", onChange, true);
    return () => {
      document.removeEventListener("click", onClick, true);
      document.removeEventListener("submit", onSubmit, true);
      document.removeEventListener("change", onChange, true);
    };
  }, []);

  return null;
}

export { sendEvent };
export default AnalyticsTracker;
